import { useMemo } from "react"

import { COVERAGE_CONFIG } from "../config/coverage.config.tsx"
import { POLICIES_CONFIG } from "../config/policies.config.tsx"
import { TOOLTIPS_CONFIG } from "../config/tooltips.config.tsx"
import { ICommonCheckResult } from "../types/objects.types.ts"

export const useWriteToEhr = (coverageCheckResult: ICommonCheckResult) => {
    // Both the main button as well as the submenu buttons need the same logic to determine if the check can be written; hence this helper function
    const determineIsWriteToEhrAllowed = (
        coverageCheckResult: ICommonCheckResult,
    ) => {
        const responseStatus =
            coverageCheckResult.IN?.coverageResult.responseStatus ||
            coverageCheckResult.OUT?.coverageResult.responseStatus

        const patientId =
            coverageCheckResult.IN?.coverageResult.customerPatientId ||
            coverageCheckResult.OUT?.coverageResult.customerPatientId

        const responseType =
            coverageCheckResult.IN?.coverageResult.responseType ||
            coverageCheckResult.OUT?.coverageResult.responseType

        const supportedResponseType =
            !!responseType &&
            COVERAGE_CONFIG.mainCoverageResponseTypes.includes(responseType)

        return {
            isWriteToEhrAllowed:
                !!patientId &&
                !!responseStatus &&
                POLICIES_CONFIG.ehrWriteAllowedResponseStatusCodes.includes(
                    responseStatus,
                ) &&
                supportedResponseType,
            // In case of both missing patient ID and incorrect status code, show the missing patient ID tooltip
            tooltip: !supportedResponseType
                ? TOOLTIPS_CONFIG.singlePolicyView.cantWriteToEhrText
                      .notSupportedCheckType
                : !patientId
                  ? TOOLTIPS_CONFIG.singlePolicyView.cantWriteToEhrText
                        .missingPatientId
                  : TOOLTIPS_CONFIG.singlePolicyView.cantWriteToEhrText
                        .inactiveCoverage,
        }
    }

    const { isWriteToEhrAllowed, tooltip } = useMemo(() => {
        return determineIsWriteToEhrAllowed(coverageCheckResult)
    }, [coverageCheckResult])

    return {
        determineIsWriteToEhrAllowed,
        isWriteToEhrAllowed,
        tooltip,
    }
}
